module.exports = __webpack_public_path__ + "static/media/project.c73e3b44.jpg";